<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds">
      <div class="user-profile-container">          
          <h1 class="govuk-heading-xl page-title">Public Procurement Gateway will be back soon</h1>
          <p class="govuk-body-l">We are busy updating Public Procurement Gateway with technology upgrades and maintenance. We apologise for the inconvinence and appreciate your patience. We should be back online soon. Thank you for your patience.</p>
      </div>
  </div>
</div>